/* eslint-disable max-classes-per-file */
import { Expose } from 'class-transformer';
import { IsEnum, IsNumber, IsOptional, IsString } from 'class-validator';

export enum LaundryVendor {
  Ideologica = 'ideologica',
}

export class Laundry {
  @IsString()
  readonly id: string;

  @IsString()
  readonly vendor: LaundryVendor;

  @Expose({ name: 'saving_rate' })
  @IsNumber()
  @IsOptional()
  readonly savingRate?: number;

  @IsString()
  readonly label: string;

  constructor(init: Laundry | Partial<Laundry>) {
    this.id = init?.id!;
    this.vendor = init?.vendor!;
    this.savingRate = init?.savingRate!;
    this.label = init?.label!;
  }
}

export class IdeologicaLaundry extends Laundry {
  @IsEnum(LaundryVendor)
  readonly vendor = LaundryVendor.Ideologica;

  constructor(init: IdeologicaLaundry) {
    super({ id: init?.id, savingRate: init?.savingRate });
  }
}

export default Laundry;
